<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <parametros-banco-precos
        ref="bancoPrecosParametros"
        :title="title"
        :items="bancoPrecosCalculos"
      />
      <v-row>
        <v-col cols="12">
          <v-btn
            id="btn-save-calculo-bp"
            color="green"
            min-width="100"
            style="float: right"
            class="mt-n5"
            @click="salvar()"
            :disabled="invalid"
            :loading="loading"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
import BancoPrecosService from '@/services/BancoPrecosCalculosService';
import tourMixins from '@/mixins/tourMixins';

export default {

  mixins: [tourMixins],

  components: {
    ParametrosBancoPrecos: () => import("@/components/bancoPrecosCalculos/ParametrosBancoPrecos.vue")
  },

  mounted() {
    if (this.$route.params.id) {
      this.getBancoPrecosCalculos(this.$route.params.id);
    }
    this.iniciarTourPagina();
  },

  data() {
    return {
      bancoPrecosCalculos: {},
      loading: false,
      arrTour: [
        {
          element: '#titulo-calculo-bp',
          intro: 'Aqui você poderá inserir um nome para seu cálculo de banco de preços.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: '#date-picker-data-inicial-calculo-bp',
          intro: 'Aqui você poderá inserir a data inicial de compra.',
          scrollTo: "tooltip",
          position: 'left'
        },
        {
          element: '#date-picker-data-final-calculo-bp',
          intro: 'Aqui você poderá inserir a data final de compra.',
          scrollTo: "tooltip",
          position: 'left'
        },
        {
          element: '#date-picker-database-calculo-bp',
          intro: 'Aqui você poderá inserir a data base.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: '#btn-save-calculo-bp',
          intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar seu cálculo de banco de preços.',
          scrollTo: "tooltip",
          position: 'left'
        },
      ]
    }
  },

  methods: {
    getBancoPrecosCalculos(id) {
      BancoPrecosService.getBancoPrecosCalculos(id).then(response => {
        this.bancoPrecosCalculos = response.data.bancoPrecosCalculos;
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao recuperar cálculo de banco de preços.', '',{position:'topRight'});
      });
    },

    salvar() {
      const data = this.$refs.bancoPrecosParametros.exportData();
      const id = !this.$route.params.id ? null : this.$route.params.id;
      this.loading = true;

      BancoPrecosService.salvar(data, id).then(() => {
        this.$toast.success('Cálculo de banco de preços salvo com sucesso.', '',{position:'topRight'})
        this.$router.push({ name: 'Banco de Precos Historico' });
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao salvar cálculo de banco de preços.', '',{position:'topRight'});
      })
      .finally(() => this.loading = false);
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  },
  
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    title() {
      return this.$route.params.id ? `Editando Cálculo de BP` : 'Adicionar Novo Cálculo de BP';
    },
  }
}
</script>